import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';
import React, { useState } from 'react';
import { Layout } from '@/components/layout/Layout';
import { Header } from '@/components/layout/header/Header';
import { DashboardControls } from './DashboardControls';
import { DashboardVideoFeed } from './feed/DashboardVideoFeed';
import { FeedVideoCardSkeleton } from './feed/FeedVideoCardSkeleton';
import { Plus } from 'lucide-react';
import { UploadQueueModal } from '@/components/upload/UploadQueueModal';

export function PremiumDashboard() {
  useLanguage();
  const isLoading = false;
  const [viewMode, setViewMode] = useState<'grid' | 'list'>('grid');
  const [searchQuery, setSearchQuery] = useState('');
  const [uploadModalOpen, setUploadModalOpen] = useState(false);
  
  if (isLoading) {
    return (
      <Layout>
        <div className="bg-background w-full">
          <Header />
          <div className="hidden lg:block h-px bg-border w-full" />
          
          <div className="px-5 md:px-6 pb-24">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
              {Array.from({ length: 8 }).map((_, i) => (
                <FeedVideoCardSkeleton key={i} />
              ))}
            </div>
          </div>
          
        </div>
      </Layout>
    );
  }
  
  return (
    <Layout>
      <div className="bg-background w-full min-h-screen flex flex-col">
        <Header />
        
        <div className="hidden lg:block h-px bg-border w-full flex-shrink-0" />
        
        {/* Área de scroll */}
        <div className="flex-1 overflow-y-auto">
          {/* Controls: Segmented + Search */}
          <div className="px-5 md:px-6 pt-5 mt-2">
            <div className="max-w-[480px] md:max-w-none mx-auto">
              <DashboardControls
                viewMode={viewMode}
                onViewModeChange={setViewMode}
                searchQuery={searchQuery}
                onSearchChange={setSearchQuery}
              />
            </div>
          </div>
          
          {/* Grid de vídeos */}
          <div className="px-5 md:px-6 pt-6 pb-[calc(120px+env(safe-area-inset-bottom))]">
            <div className="max-w-[480px] md:max-w-none mx-auto">
              <DashboardVideoFeed 
                includeNewVideoCard 
                searchQuery={searchQuery}
              />
            </div>
          </div>
        </div>
        
        {/* Mobile FAB - Adicionar Vídeos */}
        <button
          onClick={() => setUploadModalOpen(true)}
          className="
            sm:hidden fixed bottom-[18px] right-[18px] z-50
            w-[54px] h-[54px] rounded-full
            bg-[#2563EB] text-white
            shadow-[0_6px_16px_rgba(37,99,235,0.35)]
            flex items-center justify-center
            hover:bg-[#1D4ED8] active:scale-95
            transition-all duration-200
          "
          aria-label={translateInterfaceText("Adicionar vídeos")}
        >
          <Plus className="w-[22px] h-[22px]" />
        </button>

        {/* Upload Modal for FAB */}
        <UploadQueueModal 
          open={uploadModalOpen} 
          onOpenChange={setUploadModalOpen}
        />
        
        {/* VersionTag removed - component not found */}
      </div>
    </Layout>
  );
}
